// extracted by mini-css-extract-plugin
module.exports = {"googleBtn":"GoogleLoginButton_googleBtn__lpIPA"};